import { ReactElement } from 'react';

function ToastNotification(): ReactElement<HTMLDivElement> {
  return (
    <div className="mx-10 my-5 fixed bottom-0 left-0 hidden">
      <div className="mb-4 w-80 h-16 rounded-md bg-gray-200 last:mb-0"></div>
      <div className="mb-4 w-80 h-16 rounded-md bg-gray-200 last:mb-0"></div>
      <div className="mb-4 w-80 h-16 rounded-md bg-gray-200 last:mb-0"></div>
    </div>
  );
}

export default ToastNotification;
